import { render, staticRenderFns } from "./email-sent.vue?vue&type=template&id=143229af&scoped=true&"
import script from "./email-sent.vue?vue&type=script&lang=js&"
export * from "./email-sent.vue?vue&type=script&lang=js&"
import style0 from "./email-sent.vue?vue&type=style&index=0&id=143229af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143229af",
  null
  
)

export default component.exports